import React from 'react';
import { useSelector } from 'react-redux';

export const ModuleScopeContext = React.createContext(null);
const ModuleScopeProvider = ({ children }) => {
  const { scopes } = useSelector(({ signInReducer }) => {
    return {
      scopes: signInReducer.me
        ? signInReducer.me.data
          ? signInReducer.me.data.scopes
          : []
        : [],
    };
  });

  // console.log('scopes', scopes);

  // const scopes = [
  //   'approval:management:readWrite',
  //   'approval:kyc:readWrite',
  //   'approval:story:readWrite',
  //   'partialRollout: readWrite',
  //   'finance:management:readWrite',
  //   'user:management:readWrite',
  //   'approval:discovery:readWrite',
  //   'finance:discovery:readWrite',
  //   'user:discovery:readWrite',
  //   'atheneum:readWrite',
  // ];

  function matchScope(scopes, permissions, scopeMode) {
    // console.log('scopeMode', scopeMode);
    switch (scopeMode) {
      case 'allOf':
        // console.log('scopeMode1', scopeMode);
        return scopes.every((requiredScope) =>
          permissions.some((userScope) =>
            isScopeIncluded(requiredScope, userScope)
          )
        );
      case 'anyOf':
      default:
        // console.log('scopeMode2', scopeMode);
        return scopes.some((requiredScope) =>
          permissions.some((userScope) =>
            isScopeIncluded(requiredScope, userScope)
          )
        );
    }
  }

  function isScopeIncluded(requiredScope, userScope) {
    // console.log('permission1', requiredScope, userScope);
    const reqPerms = requiredScope.split(':'); //schoolManagement:readWrite
    const reqLength = reqPerms.length; //2
    const userPerms = userScope.split(':'); //schoolManagement:read
    const userLength = userPerms.length;
    // console.log('permission3', reqLength, userLength);

    if (!userPerms[userLength - 1].includes(reqPerms[reqLength - 1])) {
      // console.log('permission2', false);
      return false;
    }

    if (reqLength < userLength) {
      // console.log('permission3', reqLength, userLength, false);
      return false;
    }

    for (let i = 0; i < userLength - 1; i++) {
      if (reqPerms[i] !== userPerms[i]) {
        // console.log('permission4', false);
        return false;
      }
    }
    // console.log('permission5', true);
    return true;
  }

  function hasScope(permissionsToCheck, userPermissions, mode) {
    return matchScope(permissionsToCheck, userPermissions, mode);
  }

  const access = (showType) => {
    // console.log('permission', hasScope(showType.scope, scopes, showType.mode));
    return hasScope(showType.scope, scopes, showType.mode);
  };
  return (
    <ModuleScopeContext.Provider value={{ access }}>
      {children}
    </ModuleScopeContext.Provider>
  );
};

export default ModuleScopeProvider;
